import { combineReducers } from 'redux';
import folderReducer, {
    createFolderSaga,
    queryFolderSaga,
    getAttributionFolder
} from './folder';
import watchlistReducer, {
    queryWatchlistSaga,
    createWatchlistSaga,
    createWatchlist,
    getWatchlistById,
    getWatchlistLoaded
} from './watchlist';
import mentionSaga from './saga';

const mentionsReducer = combineReducers({
    folders: folderReducer,
    watchlists: watchlistReducer
});

const namespace = 'mentions';

export default mentionsReducer;

export {
    mentionSaga,
    namespace,
    createFolderSaga,
    queryFolderSaga,
    queryWatchlistSaga,
    createWatchlistSaga,
    getAttributionFolder,
    createWatchlist,
    getWatchlistById,
    getWatchlistLoaded
}